// extracted by mini-css-extract-plugin
export default {"tTitle":"styles_tTitle__L-ONB","tDate":"styles_tDate__p1+Jj"};